import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getRelativeTime } from '../../utils/date';
import './PostCard.css';

const PostCard = ({ post, author }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/post/${post.id}`);
  };

  // 生成文章摘要
  const generateExcerpt = (content) => {
    // 移除Markdown语法，获取纯文本
    const plainText = content
      .replace(/^#+ .+$/gm, '') // 移除标题
      .replace(/```[\s\S]*?```/g, '') // 移除代码块
      .replace(/`[^`]+`/g, '') // 移除行内代码
      .replace(/!\[.*?\]\(.*?\)/g, '') // 移除图片
      .replace(/\[.*?\]\(.*?\)/g, '') // 移除链接
      .replace(/[*_~`#>\-\+|]/g, '') // 移除Markdown符号
      .replace(/\n+/g, ' ') // 将换行转为空格
      .trim();
    
    return plainText.length > 150 
      ? plainText.substring(0, 150) + '...'
      : plainText;
  };

  const excerpt = generateExcerpt(post.content);

  return (
    <article className="post-card" onClick={handleClick}>
      <div className="post-card-header">
        <h2 className="post-card-title">
          {post.title}
        </h2>
        <div className="post-card-meta">
          {author && (
            <div className="post-card-author">
              <img 
                src={author.avatar} 
                alt={author.username}
                className="post-card-avatar"
              />
              <span>{author.username}</span>
            </div>
          )}
          <span>·</span>
          <span>{getRelativeTime(post.createdAt)}</span>
          {post.updatedAt !== post.createdAt && (
            <>
              <span>·</span>
              <span>更新于 {getRelativeTime(post.updatedAt)}</span>
            </>
          )}
        </div>
      </div>

      <div className="post-card-excerpt">
        {excerpt}
      </div>

      <div className="post-card-footer">
        <div className="post-card-tags">
          {post.tags && post.tags.map((tag, index) => (
            <span key={index} className="post-card-tag">
              {tag}
            </span>
          ))}
        </div>
        
        <div className="post-card-stats">
          <span className="post-card-stat">
            <span>👁</span>
            <span>{post.views || 0}</span>
          </span>
          <span className="post-card-stat">
            <span>❤️</span>
            <span>{post.likes || 0}</span>
          </span>
        </div>
      </div>
    </article>
  );
};

export default PostCard;